import { PALETTE, mix, useCanvasLoop } from "@/components/canvasLoop";

const rand = (i, k) => { const s = Math.sin(i * 127.1 + k * 311.7) * 43758.5453; return s - Math.floor(s); };
const PERIOD = 9;

const drawStem = (ctx, x0, base, ceiling, maxH, p, i, t) => {
  const grow = Math.min(1, p / 0.7);
  const ease = 1 - Math.pow(1 - grow, 3);
  const fade = p > 0.85 ? 1 - (p - 0.85) / 0.15 : 1;
  const tipY = base - maxH * ease;
  const freq = 0.006 + rand(i, 3) * 0.01;
  const sway = 6 + rand(i, 4) * 18;
  let px = x0, py = base;
  for (let y = base; y >= tipY; y -= 4) {
    const x = x0 + Math.sin(y * freq + rand(i, 5) * 6 + t * 0.4) * sway * ((base - y) / maxH);
    const above = y < ceiling;
    const k = above ? Math.min(1, (ceiling - y) / 60) : 0;
    const [r, g, b] = mix(PALETTE.muted, PALETTE.accent, k);
    ctx.strokeStyle = `rgba(${r},${g},${b},${(0.3 + k * 0.6) * fade})`;
    ctx.beginPath(); ctx.moveTo(px, py); ctx.lineTo(x, y); ctx.stroke();
    px = x; py = y;
  }
  const tipAbove = tipY < ceiling;
  const [r, g, b] = tipAbove ? PALETTE.accent : PALETTE.muted;
  ctx.fillStyle = `rgba(${r},${g},${b},${0.85 * fade})`;
  ctx.beginPath(); ctx.arc(px, py, tipAbove ? 2.4 : 1.6, 0, Math.PI * 2); ctx.fill();
};

const drawFrame = (ctx, w, h, t) => {
  ctx.fillStyle = PALETTE.bg;
  ctx.fillRect(0, 0, w, h);
  const mobile = w < 640;
  const count = mobile ? 30 : 64;
  const base = h * 0.94;
  const ceiling = h * 0.5;
  const [mr, mg, mb] = PALETTE.muted;
  ctx.setLineDash([3, 6]);
  ctx.strokeStyle = `rgba(${mr},${mg},${mb},0.45)`;
  ctx.lineWidth = 1;
  ctx.beginPath(); ctx.moveTo(0, ceiling); ctx.lineTo(w, ceiling); ctx.stroke();
  ctx.setLineDash([]);
  const x1 = mobile ? w * 0.06 : w * 0.38;
  const x2 = mobile ? w * 0.94 : w * 0.97;
  for (let i = 0; i < count; i++) {
    const x0 = x1 + (x2 - x1) * ((i + rand(i, 1) * 0.8) / count);
    const p = ((t + rand(i, 2) * PERIOD) % PERIOD) / PERIOD;
    const maxH = (base - ceiling) * (0.55 + rand(i, 6) * 1.25);
    drawStem(ctx, x0, base, ceiling, maxH, p, i, t);
  }
};

export const GrowthCanvas = () => {
  const ref = useCanvasLoop(drawFrame);
  return <canvas ref={ref} className="absolute inset-0 w-full h-full" aria-hidden="true" data-testid="hero-growth-canvas" />;
};
